module.exports = "/_next/static/videos/FOREST-ff08866fc44cdc60790dd8688c800021.mp4";